export default __webpack_public_path__ + "static/media/tbd.16a310ad.png";